module.exports = __webpack_public_path__ + "static/media/04.b7a88a96.jpg";